import { AppGridCreateItemButton } from "@/components/AppGrid/AppGridCreateItemButton/AppGridCreateItemButton";
import { AppGridFilter } from "@/components/AppGrid/AppGridFilter/AppGridFilter";
import { AppGridSearch } from "@/components/AppGrid/AppGridSearch/AppGridSearch";
import { AppTagFilter } from "@/components/AppGrid/AppTagFilter/AppTagFilter";
import { dealModel } from "@/models/deal";
import { getDefaultDealDirectoryEntity } from "@/models/dealDirectory";
import { Stack } from "@mantine/core";
import { colDefs } from "../colDefs";

export const Sidebar = () => {
  return (
    <Stack p="sm" h={"100%"} justify="space-between">
      <Stack>
        <AppGridCreateItemButton
          model={dealModel}
          applySortOnCreate={{
            state: [{ colId: "progressStatusTagIds", sort: "asc" }],
            defaultState: { sort: null },
          }}
        />

        <AppGridSearch />

        <AppTagFilter
          label={"Status"}
          entity={getDefaultDealDirectoryEntity()}
          resourceProp={"progressStatusTags"}
          columnId="progressStatusTagIds"
        />
      </Stack>

      <AppGridFilter colDefs={colDefs} />
    </Stack>
  );
};
